<template>
  <page :manualInit="renewalMessage.init" :manualErr="renewalMessage.initErr">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <form>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn class="mx-2" fab dark small color="teal" v-on="on" @click.native.stop="showFilterList = true">
                          <v-icon dark>mdi-format-list-bulleted</v-icon>
                        </v-btn>
                      </template>
                      <span>Show Saved Filters</span>
                    </v-tooltip>
                    Filters for {{ listMode }}
                    <span class="caption grey--text font-weight-light">
                      {{ defaultFilter.filterName !== undefined ? ' (' + defaultFilter.filterName + ')' : '' }}</span
                    >
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 md6>
                          <v-text-field
                            v-model="filters.clmNo"
                            :label="filtersLabel.clmNo"
                            :error-messages="errors.collect('clmNo')"
                            data-vv-name="clmNo"
                            :data-vv-as="filtersLabel.clmNo"
                            v-validate="'entry|max:16'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            v-model="filters.polNo"
                            :label="filtersLabel.polNo"
                            :error-messages="errors.collect('polNo')"
                            data-vv-name="polNo"
                            :data-vv-as="filtersLabel.polNo"
                            v-validate="'entry|max:16'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.native="saveFilter = true">Save Current Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-tabs v-model="tabs">
              <v-tab v-for="(detailTab, x) in detailTabs" :key="x" :disabled="disabledTabs(detailTab)" @click="doColumn(detailTab, columns)">{{
                detailTab
              }}</v-tab>
              <v-spacer></v-spacer>
              <v-btn class="mr-2 mt-2" color="primary" @click.native="doCreate()" v-if="checkAccess([permissionKeys.perm_031625])">
                <span>New Renewal Message</span>
                <v-icon right dark>mdi-plus</v-icon>
              </v-btn>
              <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                <template v-slot:activator="{ on }">
                  <v-btn color="secondary" class="white--text mr-2 mt-2" v-on="on">
                    <span>Columns</span>
                    <v-icon right dark>mdi-table-column-plus-after</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-text>
                    <template v-if="columns.length > 0">
                      <v-checkbox
                        v-for="column in columns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else>No column found</template>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-tabs>
            <v-tabs-items v-model="tabs" touchless>
              <v-tab-item :key="1">
                <v-flex xs12>
                  <v-card>
                    <v-data-table
                      v-bind:headers="listHeaders"
                      v-bind:items="items"
                      :server-items-length="totalItems"
                      :footer-props="{ 'items-per-page-options': itemsPerPage }"
                      v-bind:options.sync="pagination"
                      item-key="key"
                      :loading="loading"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td v-for="column in selectedColumns" :key="column">{{ row.item[column] }}</td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              :query="checkAccess([permissionKeys.perm_031620])"
                              @query="doQuery(row.item) && checkAccess([permissionKeys.perm_031620])"
                              :review="checkAccess([permissionKeys.perm_031615])"
                              @review="doReview(row.item) && checkAccess([permissionKeys.perm_031615])"
                              :remove="checkAccess([permissionKeys.perm_031610])"
                              @remove="doPromptRemove(row.item) && checkAccess([permissionKeys.perm_031610])"
                              :loading="loading"
                            ></table-action>
                          </td></tr
                      ></template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-flex>
      </v-layout>
      <confirm v-model="promptRemove" @ok="doRemove">
        <p>Are you sure you want to delete the selected Renewal Messages?</p>
        <div class="queryValue">Claim No.: {{ this.selectedRenMsg.clmNo }}</div>
        <div class="queryValue">Ren Cnt: {{ this.selectedRenMsg.renCnt }}</div>
        <div class="queryValue">Policy No.: {{ this.selectedRenMsg.polNo }}</div>
      </confirm>
      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-information</v-icon>
            <v-toolbar-title>System Information</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Oops something went wrong:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Common Search Filter - Start -->
      <v-dialog v-model="showFilterList" width="800px" persistent>
        <SearchFilter
          :boolRefresh="showFilterList"
          :filterTitle="'Saved Filters - Renewal Messages'"
          @close="showFilterList = false"
          :filterCode="filterCode"
          @applyDefaultFilter="applyDefaultFilter"
        ></SearchFilter>
      </v-dialog>
      <v-dialog v-model="saveFilter" width="800px" persistent>
        <UpdateSearchFilter
          :boolRefresh="saveFilter"
          :dialogTitle="'Filter'"
          :actionName="'new'"
          :filters="filters"
          @close="saveFilter = false"
          @reloadList="reloadList"
          :filterCode="filterCode"
          @applyDefaultFilter="applyDefaultFilter"
        ></UpdateSearchFilter>
      </v-dialog>
      <!-- Common Search Filter - End -->
    </v-container>
  </page>
</template>

<script>
import clone from 'clone'
import { listMixin } from '@/mixins/listMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import SearchFilter from '@/components/core/common/dialog/SearchFilter'
import UpdateSearchFilter from '@/components/core/common/dialog/UpdateSearchFilter'
import { recordLockMixin } from '@/mixins/common/recordLockMixin'
import { permissionKeys } from '@/mixins/global/permissionKey'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      // Common Search Filter - Start
      filterCode: 'RENMSG',
      newFilter: false,
      saveFilter: false,
      showFilterList: false,
      permissionKeys: permissionKeys,
      defaultFilter: {},
      // Common Search Filter - End
      visibleTab: {},
      listMode: 'Renewal Messages',
      detailTab: 'Renewal Messages Details',
      tab: undefined,
      tabs: undefined,
      buttons: undefined,
      columns: [],
      defaultColumns: [],
      filterTab: 'Renewal Messages Details',
      detailTabs: ['Renewal Messages Details'],
      selectedColumns: [],
      filtersLabel: {
        clmNo: 'Claim No.',
        polNo: 'Policy No.'
      },
      filters: {
        clmNo: undefined,
        polNo: undefined
      },
      showDetailFilters: false,
      showDeletePrompt: false,
      selectedRenMsg: {
        clmNo: undefined,
        renCnt: null,
        polNo: undefined
      },
      initialLoad: true,
      showErrorDialog: false,
      promptRemove: false,
      pagination: {
        sortDesc: [true],
        page: 1
      }
    }
  },
  watch: {
    tabs: function (value) {
      if (value === 0) {
        this.doColumn('Renewal Messages Details', this.columns)
      }
    },
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    pagination: function (value) {
      this.fetchData(false)
    },
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    visibleControl(data) {
      if (typeof data !== 'undefined') {
        this.visibleTab = { ...data }
        this.getDefaultFilter()
      } else {
        this.visibleTab = {}
      }
    },
    async doInit() {
      await this.$store.dispatch('clmRenMsgInit')
    },
    // Common Search Filter - Start
    reloadList(filterName) {
      this.defaultFilter.filterName = filterName
      this.saveFilter = false
      this.doButtons(this.visibleTab.tab)
    },
    applyDefaultFilter(filterData) {
      this.defaultFilter = filterData
      if (this.defaultFilter.filters !== undefined) {
        this.filters = this.defaultFilter.filters
      }
      this.showFilterList = false
      this.doButtons(this.visibleTab.tab)
    },
    async getDefaultFilter() {
      await Promise.all([this.$store.dispatch('searchFilterInit')])
      const apiUrl = this.$store.state.searchFilter.menu.defaultFilter
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            filterCode: this.filterCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          this.initialLoad = false
          if (data) {
            this.defaultFilter.filterName = data.defaultFilter.filterName
            this.defaultFilter.filterDesc = data.defaultFilter.filterDesc
            this.defaultFilter.filterCode = data.defaultFilter.filterCode
            this.defaultFilter.filters = JSON.parse(data.defaultFilter.filterContent)
            if (this.defaultFilter.filters !== undefined) {
              this.filters = this.defaultFilter.filters
            }
            this.doButtons(this.visibleTab.tab)
          } else {
            this.doButtons(this.visibleTab.tab)
          }
        } catch (err) {
          this.loading = false
        }
      }
    },
    async performReview(data) {
      try {
        this.loading = true
        const dispatchObj = {
          clmNo: data.item.clmNo,
          query: false
        }
        await this.$store.dispatch('loadClaim', dispatchObj)

        // Check status and redirect to the correct page
        /* // Remarked by lcd_20200918
        if (data.item.clmStat === 'O' || this.buttons === 'reopen') {
          this.$router.push({ name: 'claimHeader' })
        } else if (data.item.clmStat === 'C') {
          this.$router.push({ name: 'claimHeader' })
        } else {
          this.$toast.error('Invalid Status Code')
          this.loading = false
        }
        */
        // lcd_20200918
        if (this.buttons === undefined) {
          this.$router.push({ name: 'claimHeader' })
        } else if (this.buttons === 'reopen') {
          this.$router.push({ name: 'claimReopenHeader' })
        } else {
          this.$toast.error('Invalid Status Code')
          this.loading = false
        }
        // Dont have to set loading to false here. It should have been redirected
        // If somehow error occurs, by right they cant try to load again. Might have dirty data now
        // this.loading = false
      } catch (err) {
        if (err.response && err.response.data) {
          this.fullMessage(err.response.data)
        } else if (err.message) {
          this.errorMessage(err.message)
        }
        this.loading = false
      }
    },
    // Find Renewal Messages Detail
    async fetchData() {
      this.items = []
      let apiUrl = this.$store.state.claims.renewalMessage.menu
      // tab key change url
      if (this.filterTab === 'Renewal Messages Details') {
        apiUrl = this.$store.state.claims.renewalMessage.menu.getRenMsgList
      }
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = clone(this.filters)
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.items = []
              // Format the data here
              data.map((renMsg) => {
                const convertRenMsg = {
                  clmNo: renMsg.clmNo,
                  polNo: renMsg.polNo,
                  renCnt: renMsg.renCnt,
                  riskGrpNo: renMsg.riskGrpNo,
                  riskNo: renMsg.riskNo,
                  itemNo: renMsg.itemNo,
                  renMsg: renMsg.renMsg
                }
                this.items.push(convertRenMsg)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doColumn(detailTab, columns) {
      this.filterTab = undefined
      this.columns = []
      if (detailTab === 'Renewal Messages Details') {
        this.selectedColumns = ['clmNo', 'polNo', 'renCnt', 'riskGrpNo', 'riskNo', 'itemNo', 'renMsg']
        this.tab = 'Renewal Messages Details'
        this.filterTab = 'Renewal Messages Details'
        this.columns = Object.assign(this.columns, this.defaultColumns)
        this.columns.push(
          { text: 'Claim No.', value: 'clmNo' },
          { text: 'Policy No.', value: 'polNo' },
          { text: 'Ren Cnt', value: 'renCnt' },
          { text: 'Risk Grp', value: 'riskGrpNo' },
          { text: 'Risk No.', value: 'riskNo' },
          { text: 'Item No.', value: 'itemNo' },
          { text: 'Renewal Messages', value: 'renMsg' }
        )
        if (this.initialLoad === false) {
          this.fetchData(false)
        }
      }
    },
    disabledTabs(detailTab) {
      if (this.filters.review) {
        return false
        // if (detailTab === 'Claimant Details') {
        //   return false
        // } else if (detailTab === 'Driver Details') {
        //   return false
        // } else {
        //   return false
        // }
      }
    },
    doCreate() {
      this.$router.push({ name: 'reviewRenMsg', params: { renMsgMode: 'New' } })
    },
    doQuery(data) {
      this.$router.push({ name: 'reviewRenMsg', params: { renMsgData: data, renMsgMode: 'Query' } })
    },
    doReview(data) {
      this.$router.push({ name: 'reviewRenMsg', params: { renMsgData: data, renMsgMode: 'Review' } })
    },
    doRemove() {
      this.resetMessages()
      if (this.selectedRenMsg.clmNo !== undefined && this.selectedRenMsg.renCnt !== null && this.selectedRenMsg.polNo !== undefined) {
        const apiURI = this.$store.state.claims.renewalMessage.menu.deleteRenMsg
        if (apiURI) {
          this.$http
            .post(apiURI, this.selectedRenMsg)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.fetchData()
            })
            .catch((err) => {
              const { data } = err.response
              this.message(data)
            })
        }
      }
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selectedRenMsg.clmNo = data.clmNo
      this.selectedRenMsg.renCnt = data.renCnt
      this.selectedRenMsg.polNo = data.polNo
      this.promptRemove = true
    },
    // doButtons(data) {
    //   this.filters.review = data
    //   this.filters.clmStat = undefined
    //   if (data === 'reopen') {
    //     this.buttons = 'reopen'
    //     this.filters.clmStat = 'C'
    //     this.fetchData(true)
    //   } else if (data === 'delete') {
    //     this.buttons = 'delete'
    //     this.fetchData(true)
    //   } else if (data === 'listing') {
    //     this.buttons = 'listing'
    //     this.fetchData(true)
    //   } else if (data === 'payment') {
    //     this.buttons = 'payment'
    //     this.fetchData(true)
    //   } else {
    //     this.fetchData(false)
    //   }
    //   // if (data === 'reopen') {
    //   //   this.listMode = 'Reopen Claim'
    //   // }
    // },
    doClearFilters() {
      this.filters.clmNo = null
      this.filters.polNo = null
      this.tab = 0
      this.defaultFilter = {}
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.tab = 0
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    }
  },
  mounted() {
    this.doInit()
    // AR: OS-660 Added to check record lock 2021-01-21
    this.initCommonUtilMenu()
  },
  created() {},
  computed: {
    ...mapGetters(['checkAccess']),
    renewalMessage() {
      return this.$store.state.claims.renewalMessage
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  mixins: [listMixin, recordLockMixin],
  components: {
    SearchFilter,
    UpdateSearchFilter
  }
}
</script>

<style lang="scss"></style>
